export const dtGPTGetters = {
  chats: state => state.chats,
  chat: state => state.chat,
  conversations: state => state.conversations,
  sendChatMessageLoading: state => state.sendChatMessageLoading,
}